import { translationEngDefault as SkhemataFaqCategories } from '../SkhemataFaqCategories/eng';
import { translationEngDefault as SkhemataFaqList } from '../SkhemataFaqList/eng';
import { translationEngDefault as SkhemataFaqPost } from '../SkhemataFaqPost/eng';
import { translationEngDefault as SkhemataFaqSearch } from '../SkhemataFaqSearch/eng';
export const translationEngDefault = {
    ...SkhemataFaqCategories,
    ...SkhemataFaqSearch,
    ...SkhemataFaqList,
    ...SkhemataFaqPost
};
//# sourceMappingURL=eng.js.map